// extracted by mini-css-extract-plugin
export default {"previewContainer":"FileUpload_previewContainer__8xT5A","relative":"FileUpload_relative__pszVf","nowrap":"FileUpload_nowrap__RQOA+"};